// extracted by mini-css-extract-plugin
module.exports = {"collaborator-icon":"O3JuKjQd9o","collaboratorIcon":"O3JuKjQd9o"};
    if(module.hot) {
      // 1597843259358
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  